import { render, staticRenderFns } from "./MyColorPicker2.vue?vue&type=template&id=731025be&scoped=true&"
import script from "./MyColorPicker2.vue?vue&type=script&lang=js&"
export * from "./MyColorPicker2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731025be",
  null
  
)

export default component.exports